/**
 * @Author: memo
 * @Date:   2020-02-16T13:32:09-06:00
 * @Email:  g.correa@kimeras-studio.com
 * @Project: Farmazon API
 * @Last modified by:   memo
 * @Last modified time: 2020-02-17T21:56:50-06:00
 * @License: MIT
 */


import axios from "axios";

import React from 'react';
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

import jwt_decode from "jwt-decode";

import setAuthToken from "./utils/setAuthToken";
import { Provider } from "react-redux";
import store from "./store";
import { setCurrentUser, logoutUser } from "./actions/authActions";

import Login from "./components/auth/Login";
import Layout from "./components/dashboard/Layout";
import PrivateRoute from "./components/private-route/PrivateRoute";
import './App.css';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import NotFound from "./components/404/404";

// localStorage.removeItem("jwtTokenTeams");
// localStorage.removeItem("jwtTokenFarmazon");
// Check for token to keep user logged in
// console.log("localStorage:"+ JSON.parse(JSON.stringify(localStorage)))

if (localStorage.jwtTokenFarmazon) {
	// Set auth token header auth
	const token = JSON.parse(localStorage.jwtTokenFarmazon);
	setAuthToken(token);

	// Decode token and get user info and exp
	const decoded = jwt_decode(token);

	axios.defaults.headers.common = {
		'Authorization': 'Bearer ' + token
	};

	// Set user and isAuthenticated
	store.dispatch(setCurrentUser(decoded));

	// Check for expired token
	const currentTime = Date.now() / 1000; // to get in milliseconds
	if (decoded.exp < currentTime) {
		// Logout user
		store.dispatch(logoutUser());

		// Redirect to login
		window.location.href = "./";
	}
}


function App() {
	return (
		<Provider store={store}>
			<Router>
				<div className="App">
					<Switch>
						<Route exact path="/" component={Login} />

						<PrivateRoute exact path="/dashboard" component={Layout} />
						<MuiThemeProvider>
							<Route
								component={localStorage.jwtTokenFarmazon ? Layout : NotFound}
							/>
						</MuiThemeProvider>
					</Switch>
				</div>
			</Router>
		</Provider>
	);
}

export default App;
